unit unit_Artikelsuche;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Data.DB, WEBLib.DB, XData.Web.JsonDataset,
  XData.Web.Dataset, XData.Web.Connection, Vcl.Controls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.ExtCtrls, Vcl.Grids, WEBLib.DBCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes,
  VCL.TMSFNCCustomControl, VCL.TMSFNCTableView, WEBLib.Buttons, WEBLib.Grids, DB;

type
  TfrmArtikelsuche = class(TForm)
    DataSet: TXDataWebDataSet;
    Source: TDataSource;
    DataSetArtikelnummer: TStringField;
    DataSetArtikelueberschrift: TStringField;
    DataSetArtikelbeschreibung: TStringField;
    DataSetVerkaufspreis: TFloatField;
    DataSetBestand: TFloatField;
    TC: TTableControl;
    DataSetArtikelmatchcode: TStringField;
    DataSetEAN: TStringField;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    Container3: THTMLContainer;
    btnzurueck: TButton;
    btnScan: TButton;
    ResultLabel: TLabel;
    edtSuchbegriff: TEdit;
    btnNurArtikelMitBestand: TButton;
    procedure WebFormShow(Sender: TObject);
    procedure DataSetAfterOpen(DataSet: TDataSet);
    procedure btnzurueckClick(Sender: TObject);
    procedure btnScanClick(Sender: TObject);
    procedure edtSuchbegriffChange(Sender: TObject);
    procedure ResultLabelClick(Sender: TObject);
    procedure btnNurArtikelMitBestandClick(Sender: TObject);

    public
    Artikelnummer:string;
    NurArtikelMitBestand:boolean;
    weiterzueinzelartikel:boolean;
    buttonartikelnummer:TButton;
    procedure buttonartikelnummerclick(Sender:TObject);
  protected procedure LoadDFMValues; override; end;

var
  frmArtikelsuche: TfrmArtikelsuche;

implementation
  uses unit1, unit2, unit_Artikel, unit_BarcodeScan;
{$R *.dfm}

procedure TfrmArtikelsuche.btnNurArtikelMitBestandClick(Sender: TObject);
begin
  if NurArtikelMitBestand=false then NurArtikelMitBestand:=true else NurArtikelMitBestand:=false;
  if NurArtikelMitBestand=false then btnNurArtikelMitBestand.Caption:='mit Bestand';
  if NurArtikelMitBestand=true then btnNurArtikelMitBestand.Caption:='Bestand egal';
  edtSuchbegriffChange(self);
end;

procedure TfrmArtikelsuche.btnScanClick(Sender: TObject);
var
  LFrm:TBarcodeScan;
  procedure AfterCreate(AForm:TObject);
  var
    LForm:TBarcodeScan;
    begin
      LForm:=(AForm as TBarcodeScan);
      //lform.mykundehint:=xdsEinzelkontaktKundennummer.AsString+' '+xdsEinzelkontaktNachname.AsString+', '+xdsEinzelkontaktVorname.asstring;
      //lForm.edttoaddress.Text:= xdsEinzelkontaktPostleitzahl.AsString+' '+xdsEinzelkontaktort.AsString+', '+xdsEinzelkontaktStrasse.AsString;

    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      edtsuchbegriff.text:=trim(lfrm.ScanErgebnis);
      edtsuchbegriffChange(self);
    end;
  begin
    if LizenzOK then
    begin
      LFrm:=TBarcodeScan.CreateNew(@AfterCreate);
      LFrm.ShowModal(@AfterShowmodal);
    end
    else
    begin
      showmessage('Für diese Funktion sind Sie noch nicht freigeschaltet, bitte erwerben Sie eine Lizenz');
    end;
end;

procedure TfrmArtikelsuche.btnzurueckClick(Sender: TObject);
begin
  self.Close;
end;

procedure TfrmArtikelsuche.buttonartikelnummerclick(Sender:TObject);
var
  MFrm:TfrmArtikel;
    procedure AfterCreate(AForm:TObject);
    begin
      (AForm as TfrmArtikel).edtArtikelnummer.text:=Artikelnummer;
      (AForm as TfrmArtikel).edtArtikelnummerChange(nil);
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      edtsuchbegriffChange(nil);
    end;

  begin
  Artikelnummer:=(sender as TButton).Caption;

  if weiterzueinzelartikel then
  begin
    tc.Visible:=false;
    MFrm:=TfrmArtikel.CreateNew(@AfterCreate);
    MFrm.ShowModal(@AfterShowmodal);

  end
  else
  begin
    self.close;
  end;
end;

procedure TfrmArtikelsuche.DataSetAfterOpen(DataSet: TDataSet);
var
  i:integer;
  myelement:TJSHTMLElement;
begin
  i:=0;
  TC.visible:=true;
  TC.ColCount:=6;
  tc.RowCount:=dataset.RecordCount+1;
  tc.Cells[0,i]:='Artikelnummer';
  tc.Cells[1,i]:='Artikelüberschrift';
  tc.Cells[2,i]:='Artikelbeschreibung';
  tc.Cells[3,i]:='Bestand';
  tc.Cells[4,i]:='EAN';
  tc.Cells[5,i]:='Matchcode';
  dataset.First;
  if dataset.RecordCount=0 then ResultLabel.HTML:='nichts gefunden';
  if dataset.RecordCount>0 then ResultLabel.HTML:='Übereinstimmungen: '+inttostr(dataset.RecordCount);
  if dataset.RecordCount>20 then ResultLabel.HTML:='mehr als 20 Übereinstimmungen <I><U>mehr anzeigen</I></U>';
  if dataset.RecordCount>22 then ResultLabel.HTML:='Übereinstimmungen: '+inttostr(dataset.RecordCount)+' (max. Anzeige: 500)';


  while not dataset.eof do
  begin
    inc(i);
    myelement:=TC.cellelements[0,i];
    myelement.innerHTML:='';
    buttonartikelnummer:=TButton.Create(self);
    buttonartikelnummer.ElementClassName:='btn btn-sm btn-info';
    buttonartikelnummer.HeightStyle:=ssauto;
    buttonartikelnummer.Width:=150;
    buttonartikelnummer.tag:=0;
    buttonartikelnummer.Caption:=DataSetArtikelnummer.AsString;
    buttonartikelnummer.OnClick:=@buttonartikelnummerClick;
    buttonartikelnummer.ParentElement:=myelement;
    TC.Cells[1,i]:=DataSetArtikelueberschrift.AsString;
    TC.Cells[2,i]:=leftstr(DataSetArtikelbeschreibung.AsString,250);
    TC.Cells[3,i]:=DataSetBestand.AsString;
    TC.Cells[4,i]:=DataSetEAN.AsString;
    TC.Cells[5,i]:=DataSetArtikelmatchcode.AsString;
    dataset.Next;
  end;

  btnNurArtikelMitBestand.Enabled:=true;
end;



procedure TfrmArtikelsuche.edtSuchbegriffChange(Sender: TObject);
var
  suchtext:string;
begin
  suchtext:=trim(edtsuchbegriff.Text);
  if length(suchtext)>0 then
  begin
    if NurArtikelMitBestand=false then
    begin
      dataset.Close;
      dataset.QueryTop:=21;
      dataset.QueryString:='$filter=(contains(Artikelueberschrift, '''+suchtext+''') OR contains(Artikelnummer, '''+suchtext+''') OR contains(EAN, '''+suchtext+''') OR contains(Artikelmatchcode, '''+suchtext+''') OR contains(Artikelbeschreibung, '''+suchtext+''')) AND Artikelnichtmehrgueltig eq 0 ';
      dataset.Load;
    end
    else
    begin
      dataset.Close;
      dataset.QueryTop:=21;
      dataset.QueryString:='$filter=(contains(Artikelueberschrift, '''+suchtext+''') OR contains(Artikelnummer, '''+suchtext+''') OR contains(EAN, '''+suchtext+''') OR contains(Artikelmatchcode, '''+suchtext+''') OR contains(Artikelbeschreibung, '''+suchtext+''')) AND Artikelnichtmehrgueltig eq 0 AND Bestand gt 0';
      dataset.Load;
    end;
  end;
end;


procedure TfrmArtikelsuche.ResultLabelClick(Sender: TObject);
begin
  if Pos('mehr anzeigen',resultlabel.html,0)>1 then
  begin
    dataset.close;
    dataset.QueryTop:=501;
    dataset.Load;
  end;
end;

procedure TfrmArtikelsuche.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>Artikelsuche</h5></nav>';
  Container2.HTML.Text:='';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  btnNurArtikelMitBestand.ParentElement:=myelement;
  btnscan.ParentElement:=myelement;
  container2.ParentElement:=myelement;
  Container3.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  resultlabel.Caption:='Suchbegriff';
  resultlabel.ParentElement:=myelement;
  edtsuchbegriff.ParentElement:=myelement;
  myelement:=container3.ElementHandle;
  TC.ParentElement:=myelement;
  TC.Visible:=false;
  artikelnummer:='';
  NurartikelmitBestand:=false;
  btnNurArtikelMitBestand.Enabled:=false;
  edtsuchbegriff.SetFocus;
end;

procedure TfrmArtikelsuche.LoadDFMValues;
begin
  inherited LoadDFMValues;

  ResultLabel := TLabel.Create(Self);
  TC := TTableControl.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  Container3 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  btnScan := TButton.Create(Self);
  edtSuchbegriff := TEdit.Create(Self);
  btnNurArtikelMitBestand := TButton.Create(Self);
  DataSet := TXDataWebDataSet.Create(Self);
  DataSetArtikelnummer := TStringField.Create(Self);
  DataSetArtikelueberschrift := TStringField.Create(Self);
  DataSetArtikelbeschreibung := TStringField.Create(Self);
  DataSetVerkaufspreis := TFloatField.Create(Self);
  DataSetBestand := TFloatField.Create(Self);
  DataSetArtikelmatchcode := TStringField.Create(Self);
  DataSetEAN := TStringField.Create(Self);
  Source := TDataSource.Create(Self);

  ResultLabel.BeforeLoadDFMValues;
  TC.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  Container3.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  btnScan.BeforeLoadDFMValues;
  edtSuchbegriff.BeforeLoadDFMValues;
  btnNurArtikelMitBestand.BeforeLoadDFMValues;
  DataSet.BeforeLoadDFMValues;
  DataSetArtikelnummer.BeforeLoadDFMValues;
  DataSetArtikelueberschrift.BeforeLoadDFMValues;
  DataSetArtikelbeschreibung.BeforeLoadDFMValues;
  DataSetVerkaufspreis.BeforeLoadDFMValues;
  DataSetBestand.BeforeLoadDFMValues;
  DataSetArtikelmatchcode.BeforeLoadDFMValues;
  DataSetEAN.BeforeLoadDFMValues;
  Source.BeforeLoadDFMValues;
  try
    Name := 'frmArtikelsuche';
    Width := 173;
    Height := 344;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Visible := True;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    ResultLabel.SetParentComponent(Self);
    ResultLabel.Name := 'ResultLabel';
    ResultLabel.Left := 8;
    ResultLabel.Top := 288;
    ResultLabel.Width := 60;
    ResultLabel.Height := 15;
    ResultLabel.Caption := 'ResultLabel';
    ResultLabel.ElementClassName := 'h6 m-2';
    ResultLabel.ElementFont := efCSS;
    ResultLabel.ElementPosition := epIgnore;
    ResultLabel.HeightStyle := ssAuto;
    ResultLabel.HeightPercent := 100.000000000000000000;
    ResultLabel.WidthStyle := ssPercent;
    ResultLabel.WidthPercent := 100.000000000000000000;
    SetEvent(ResultLabel, Self, 'OnClick', 'ResultLabelClick');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 141;
    TC.Width := 169;
    TC.Height := 79;
    TC.ElementClassName := 'table table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 3;
    TC.ColHeader := False;
    TC.ElementFont := efCSS;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-hover table-bordered table-striped';
    TC.WordWrap := True;
    TC.ColCount := 1;
    TC.RowCount := 5;
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epRelative;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'd-flex flex-wrap m-1 border border-info';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    Container3.SetParentComponent(Self);
    Container3.Name := 'Container3';
    Container3.Left := 0;
    Container3.Top := 94;
    Container3.Width := 169;
    Container3.Height := 41;
    Container3.ElementClassName := 'd-flex m-1';
    Container3.HeightStyle := ssPercent;
    Container3.WidthStyle := ssAuto;
    Container3.ChildOrder := 2;
    Container3.ElementFont := efCSS;
    Container3.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 226;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    btnScan.SetParentComponent(Self);
    btnScan.Name := 'btnScan';
    btnScan.Left := 0;
    btnScan.Top := 257;
    btnScan.Width := 96;
    btnScan.Height := 25;
    btnScan.Caption := 'Bar-/QR-Code scannen';
    btnScan.ChildOrder := 4;
    btnScan.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnScan.ElementFont := efCSS;
    btnScan.ElementPosition := epIgnore;
    btnScan.HeightStyle := ssAuto;
    btnScan.HeightPercent := 100.000000000000000000;
    btnScan.WidthStyle := ssAuto;
    btnScan.WidthPercent := 100.000000000000000000;
    SetEvent(btnScan, Self, 'OnClick', 'btnScanClick');
    edtSuchbegriff.SetParentComponent(Self);
    edtSuchbegriff.Name := 'edtSuchbegriff';
    edtSuchbegriff.Left := 8;
    edtSuchbegriff.Top := 307;
    edtSuchbegriff.Width := 150;
    edtSuchbegriff.Height := 22;
    edtSuchbegriff.ChildOrder := 6;
    edtSuchbegriff.ElementClassName := 'form-control input-sm m-1';
    edtSuchbegriff.ElementFont := efCSS;
    edtSuchbegriff.ElementPosition := epIgnore;
    edtSuchbegriff.HeightStyle := ssAuto;
    edtSuchbegriff.HeightPercent := 100.000000000000000000;
    edtSuchbegriff.ShowHint := True;
    edtSuchbegriff.TextHint := 'Suchbegriff eingeben';
    edtSuchbegriff.WidthPercent := 60.000000000000000000;
    SetEvent(edtSuchbegriff, Self, 'OnChange', 'edtSuchbegriffChange');
    btnNurArtikelMitBestand.SetParentComponent(Self);
    btnNurArtikelMitBestand.Name := 'btnNurArtikelMitBestand';
    btnNurArtikelMitBestand.Left := 102;
    btnNurArtikelMitBestand.Top := 226;
    btnNurArtikelMitBestand.Width := 96;
    btnNurArtikelMitBestand.Height := 25;
    btnNurArtikelMitBestand.Caption := 'mit Bestand';
    btnNurArtikelMitBestand.ChildOrder := 4;
    btnNurArtikelMitBestand.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnNurArtikelMitBestand.ElementFont := efCSS;
    btnNurArtikelMitBestand.ElementPosition := epIgnore;
    btnNurArtikelMitBestand.HeightStyle := ssAuto;
    btnNurArtikelMitBestand.HeightPercent := 100.000000000000000000;
    btnNurArtikelMitBestand.WidthStyle := ssAuto;
    btnNurArtikelMitBestand.WidthPercent := 100.000000000000000000;
    SetEvent(btnNurArtikelMitBestand, Self, 'OnClick', 'btnNurArtikelMitBestandClick');
    DataSet.SetParentComponent(Self);
    DataSet.Name := 'DataSet';
    DataSet.AfterOpen := DataSetAfterOpen;
    DataSet.EntitySetName := 'Artikel';
    DataSet.Connection := DM2.XDataWebConnection1;
    DataSet.QueryTop := 21;
    DataSet.Left := 56;
    DataSet.Top := 72;
    DataSetArtikelnummer.SetParentComponent(DataSet);
    DataSetArtikelnummer.Name := 'DataSetArtikelnummer';
    DataSetArtikelnummer.FieldName := 'Artikelnummer';
    DataSetArtikelnummer.Required := True;
    DataSetArtikelnummer.Size := 25;
    DataSetArtikelueberschrift.SetParentComponent(DataSet);
    DataSetArtikelueberschrift.Name := 'DataSetArtikelueberschrift';
    DataSetArtikelueberschrift.FieldName := 'Artikelueberschrift';
    DataSetArtikelueberschrift.Size := 50;
    DataSetArtikelbeschreibung.SetParentComponent(DataSet);
    DataSetArtikelbeschreibung.Name := 'DataSetArtikelbeschreibung';
    DataSetArtikelbeschreibung.FieldName := 'Artikelbeschreibung';
    DataSetArtikelbeschreibung.Size := 255;
    DataSetVerkaufspreis.SetParentComponent(DataSet);
    DataSetVerkaufspreis.Name := 'DataSetVerkaufspreis';
    DataSetVerkaufspreis.FieldName := 'Verkaufspreis';
    DataSetBestand.SetParentComponent(DataSet);
    DataSetBestand.Name := 'DataSetBestand';
    DataSetBestand.FieldName := 'Bestand';
    DataSetArtikelmatchcode.SetParentComponent(DataSet);
    DataSetArtikelmatchcode.Name := 'DataSetArtikelmatchcode';
    DataSetArtikelmatchcode.FieldName := 'Artikelmatchcode';
    DataSetArtikelmatchcode.Size := 30;
    DataSetEAN.SetParentComponent(DataSet);
    DataSetEAN.Name := 'DataSetEAN';
    DataSetEAN.FieldName := 'EAN';
    DataSetEAN.Size := 15;
    Source.SetParentComponent(Self);
    Source.Name := 'Source';
    Source.DataSet := DataSet;
    Source.Left := 56;
    Source.Top := 144;
  finally
    ResultLabel.AfterLoadDFMValues;
    TC.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    Container3.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    btnScan.AfterLoadDFMValues;
    edtSuchbegriff.AfterLoadDFMValues;
    btnNurArtikelMitBestand.AfterLoadDFMValues;
    DataSet.AfterLoadDFMValues;
    DataSetArtikelnummer.AfterLoadDFMValues;
    DataSetArtikelueberschrift.AfterLoadDFMValues;
    DataSetArtikelbeschreibung.AfterLoadDFMValues;
    DataSetVerkaufspreis.AfterLoadDFMValues;
    DataSetBestand.AfterLoadDFMValues;
    DataSetArtikelmatchcode.AfterLoadDFMValues;
    DataSetEAN.AfterLoadDFMValues;
    Source.AfterLoadDFMValues;
  end;
end;

end.
